import { render, staticRenderFns } from "./ItinerarySectionItemOpeningHourSeasonItem.vue?vue&type=template&id=5275090f&scoped=true&"
import script from "./ItinerarySectionItemOpeningHourSeasonItem.vue?vue&type=script&lang=js&"
export * from "./ItinerarySectionItemOpeningHourSeasonItem.vue?vue&type=script&lang=js&"
import style0 from "./ItinerarySectionItemOpeningHourSeasonItem.vue?vue&type=style&index=0&id=5275090f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5275090f",
  null
  
)

export default component.exports